const moment = require('moment')

function countRemainingQuarterMonths (firstMonth, currentMonth) {
  const monthIndex = (currentMonth - firstMonth) + 12
  return 2 - (monthIndex % 3)
}

function endOfGrain (firstMonth, grain, inputMoment) {
  const copy = moment(inputMoment)
  if (grain !== 'quarter' || firstMonth === 0) {
    return copy.endOf(grain)
  }

  const currentMonth = inputMoment.month()
  const remainingMonths = countRemainingQuarterMonths(firstMonth, currentMonth)
  return copy.add(remainingMonths, 'months').endOf('month')
}

module.exports = endOfGrain
